import React from 'react';
import classNames from 'classnames';
import StaticField from '../../staticField/components/StaticField';
import CircularProgress from '../../progressIndicator/components/CircularProgress';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
var CollectionSuggestionRow = function (_a) {
    var label = _a.label, onAccept = _a.onAccept, onDecline = _a.onDecline, item = _a.item;
    var tooltip = {
        value: item.name,
        description: item.description
    };
    return (React.createElement("div", { className: classNames('collectionField__row collectionField__row--suggestion') },
        React.createElement("div", { className: 'collectionField__rowItem' },
            React.createElement(CircularProgress, { value: item.relevance }),
            React.createElement(StaticField, { name: 'collectionField__suggestion', value: item.name, label: label, tooltip: tooltip })),
        React.createElement("div", { className: 'collectionField__rowButton' },
            React.createElement(AccurityIconButton, { iconName: "mui:Check", size: "small", onClick: function () { return onAccept(item); } }),
            React.createElement(AccurityIconButton, { iconName: "mui:Close", size: "small", onClick: function () { return onDecline(item); } }))));
};
export default CollectionSuggestionRow;
//# sourceMappingURL=CollectionSuggestionRow.js.map